import React from 'react';
import DraggableList from 'shared/ui/DraggableList';
import ImageGallery from 'shared/ui/ImageGallery';
import ItemSelector from 'shared/ui/ItemSelector';
import { listingService } from 'features/app/api';
import { formatDate } from 'shared/utils/format';

const ListingsDraggableList = (props) => {
  // Define filter options
  const filterOptions = [
    {
      key: 'title',
      label: 'Наименование',
      field: (props) => (
        <input
          type="text"
          placeholder="Наименование"
          value={props.value}
          className={props.className}
          onChange={(e) => props.onChange(e.target.value)}
        />
      ),
      initialValue: ''
    },
    {
      key: 'is_archived',
      label: 'Статус',
      field: ({ value, onChange, className }) => (
        <select
          value={value}
          onChange={(e) => onChange(e.target.value)}
          className={className}
        >
          <option value="">Все</option>
          <option value="False">Активные</option>
          <option value="True">Архивированные</option>
        </select>
      ),
      initialValue: props.isArchived ? 'True' : 'False'
    },
    {
      key: 'parent_assortment',
      label: 'Ассортимент',
      field: ({ value, onChange, className }) => (
        <ItemSelector
          targetUrl="/crm/admin-api/assortments"
          onSelect={(item) => onChange([item])}
          onRemove={() => onChange([])}
          selectedItems={value}
          placeholder="Выберите ассортимент"
          searchPlaceholder="Поиск ассортимента..."
          noItemsFoundText="Ассортимент не найден"
          isMultiSelect={false}
        />
      ),
      initialValue: []
    }
  ];

  // Define columns
  const columns = [
    { key: 'id', label: 'ID', hide: true },
    { key: 'title', label: 'Наименование' },
    { 
      key: 'path', 
      label: 'Путь',
      component: (item) => <span>{item.path}</span> 
    },
    { 
      key: 'created', 
      label: 'Создан', 
      component: (item) => (
        <span>
          {formatDate(item.created)}
        </span>
      ) 
    },
    {
      key: 'main_image',
      label: 'Изображение',
      component: (item) => (
        <ImageGallery urls={item.pictures} height='h-32' width='w-32' />
      )
    },
    {
      key: 'actions',
      label: 'Действия',
      component: (item) => (
        <div className="flex space-x-2" onClick={(e) => e.stopPropagation()}>
          <button 
            onClick={() => handleArchiveToggle(item)}
            className={`text-white ${item.is_archived ? 'bg-green-500 hover:bg-green-700' : 'bg-red-500 hover:bg-red-700'} rounded px-3 py-1`}
          >
            {item.is_archived ? 'Восстановить' : 'В архив'}
          </button>
          <button
            onClick={() => handleEdit(item)}
            className="text-white bg-blue-500 hover:bg-blue-700 rounded px-3 py-1"
          >
            Изменить
          </button>
        </div>
      )
    }
  ];

  // Handler functions
  const handleArchiveToggle = (item) => {
    const confirmMessage = item.is_archived 
      ? 'Вы уверены, что хотите восстановить этот листинг?' 
      : 'Вы уверены, что хотите архивировать этот листинг?';
    
    if (window.confirm(confirmMessage)) {
      listingService.toggleArchive(item.id, !item.is_archived)
        .then(() => {
          // Refresh list will be handled by the DraggableList component
        })
        .catch(error => {
          console.error('Error toggling archive status:', error);
        });
    }
  };

  const handleEdit = (item) => {
    // Navigate to edit page or open edit modal
    window.location.href = `/app/listings/${item.id}/edit`;
  };

  return (
    <DraggableList
      targetUrl="/crm/admin-api/listings"
      updatePriorityEndpoint="/crm/admin-api/listings/update-priority"
      filterOptions={filterOptions}
      columns={columns}
      ItemComponent={props.ItemComponent}
      priorityFieldName="priority"
    />
  );
};

export default ListingsDraggableList;